import {values} from 'lodash';

export interface IQueueItem<TDataType> {
  data: TDataType;
  isUndo: boolean;
}

export class ActionQueue<TDataType> {
  private queue: { [ id: number ]: IQueueItem<TDataType> } = { };

  mark(id: number, data: TDataType) {
    const item = this.queue[id];

    if (item && item.isUndo) {
      delete this.queue[id];
    } else {
      this.queue[id] = {
        data: data,
        isUndo: false
      };
    }
  }

  undo(id: number, data: TDataType) {
    const item = this.queue[id];

    if (item && !item.isUndo) {
      delete this.queue[id];
    } else {
      this.queue[id] = {
        data: data,
        isUndo: true
      };
    }
  }

  getActions(): IQueueItem<TDataType>[] {
    return values(this.queue);
  }

  clear() {
    this.queue = {};
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/shared/action-queue.ts